import { render, staticRenderFns } from "./LazyTree.vue?vue&type=template&id=07fac597&scoped=true&xmlns%3Ael-col=http%3A%2F%2Fwww.w3.org%2F1999%2Fhtml"
import script from "./LazyTree.vue?vue&type=script&lang=js"
export * from "./LazyTree.vue?vue&type=script&lang=js"
import style0 from "./LazyTree.vue?vue&type=style&index=0&id=07fac597&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07fac597",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\git\\platform_el\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('07fac597')) {
      api.createRecord('07fac597', component.options)
    } else {
      api.reload('07fac597', component.options)
    }
    module.hot.accept("./LazyTree.vue?vue&type=template&id=07fac597&scoped=true&xmlns%3Ael-col=http%3A%2F%2Fwww.w3.org%2F1999%2Fhtml", function () {
      api.rerender('07fac597', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dataset/data/components/LazyTree.vue"
export default component.exports